var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Scanning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 9a29 29 0 100 58 29 29 0 000-58zm0 54a24.87 24.87 0 01-15.38-5.31l3.21-3.21A20.49 20.49 0 1038 17.5v4a16.5 16.5 0 11-9.31 30.11L32 48.35A12 12 0 1038 26v4.5a7.5 7.5 0 010 15 8.77 8.77 0 01-6.42-3.13L19.34 54.61A25 25 0 1138 63zm0-29a4 4 0 110 8 4 4 0 010-8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Scanning.739a58e9.svg";
export { SvgJ2Scanning as ReactComponent };